// extracted by mini-css-extract-plugin
export default {"mobileSearchDropdownsPlaceholderContainer":"mobileSearchDropdownsPlaceholderContainer__YTM5N","mobileDropdownPlaceholder":"mobileDropdownPlaceholder__NzcyY","v2":"v2__ZTM3M"};